module.exports = __webpack_public_path__ + "img/qysj_bg2.1164d6c6.png";